<template>
	<div>
		<base-header class="pb-6 bg-light">
			<!-- Page header -->
			<b-row aling-v="center" class="py-4">
				<b-col cols="12" lg="6">
					<h6 class="h2 d-inline-block mb-0 text-dark">Subscriber Usage</h6>
				</b-col>
				<b-col cols="12" lg="6" class="text-right">
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<route-bread-crumb></route-bread-crumb>
					</nav>
				</b-col>
			</b-row>
		</base-header>

		<b-container>
			<b-row class="mt-4">
				<b-col sm="12" md="12" lg="3">
					<b-card>
						<!-- Time period form -->
						<b-form>
              <b-row class="align-items-end">
                <b-col sm="6" md="6" lg="12">
                  <label for="chart-date" :class="infoFieldsClass">Enter IMSI</label>
                  <b-form-input
                    id="imsi"
                    v-model="imsiSearch"
                    placeholder="Enter IMSI"
                    :state="!searchDisabled"
                    type="number"
                    size="sm"
                  >
                  </b-form-input>
                </b-col>
                <b-col sm="6" md="6" lg="12" class="mt-2">
                  <label for="chartInterval" :class="infoFieldsClass">Select time Interval</label>
                  <b-select
                    id="chartInterval"
                    size="sm"
                    v-model="chartInterval"
                    :options="chartIntervalOptions"
                  >
                  </b-select>
                </b-col>
                <b-col data-cy="start-date-cont" sm="6" md="6" lg="12" class="mt-2">
                  <div v-if="chartInterval === 'Hourly'">
                    <label for="chart-date" :class="infoFieldsClass">Start Date</label>
                    <b-form-input id="chart-date" v-model="fromDate" size="sm" type="date" />
                  </div>
                  <div v-if="chartInterval === 'Daily'">
                    <label for="chart-date" :class="infoFieldsClass">Start Date</label>
                    <b-form-input
                      id="chart-date"
                      v-model="fromDate"
                      size="sm"
                      type="date"
                    />
                  </div>
                  <div v-if="chartInterval === 'Monthly'">
                    <label for="chart-date" :class="infoFieldsClass">Start Month</label>
                    <month-picker-input
                      :default-month="new Date().getMonth()"
                      :default-year="new Date().getFullYear()"
                      @input="setStartMonth"
                      style="z-index: 20"
                      :show-year="true"
                    ></month-picker-input>
                  </div>
                  <div v-if="chartInterval === 'Yearly'">
                    <label for="from-date" :class="infoFieldsClass">Select Start Year</label>
                    <b-form-input id="from-date" v-model="fromYear" size="sm" type="number" />
                  </div>
                </b-col>

                <b-col v-if="chartInterval === 'Hourly'" sm="6" md="6" lg="12" class="mt-2">
                  <label for="start-time" :class="infoFieldsClass">Start Time</label>
                    <b-form-input
                      id="start-time"
                      v-model="startTime"
                      size="sm"
                      type="time"
                    />
                </b-col>

                <b-col data-cy="end-date-cont" sm="6" md="6" lg="12" class="mt-2">
                  <div v-if="chartInterval === 'Hourly'">
                    <label for="chart-date" :class="infoFieldsClass">End Date</label>
                    <b-form-input id="chart-date" v-model="toDate" size="sm" type="date" />
                  </div>
                  <div v-if="chartInterval === 'Daily'">
                    <label for="chart-date" :class="infoFieldsClass">End Date</label>
                    <b-form-input id="chart-date" v-model="toDate" size="sm" type="date" />
                  </div>
                  <div v-if="chartInterval === 'Monthly'">
                    <label for="chart-date" :class="infoFieldsClass">End Month</label>
                    <month-picker-input
                      :default-month="new Date().getMonth() + 1"
                      :default-year="new Date().getFullYear()"
                      @input="setEndMonth"
                    ></month-picker-input>
                  </div>
                  <div v-if="chartInterval === 'Yearly'">
                    <label for="to-date" :class="infoFieldsClass">Select End Year</label>
                    <b-form-input id="to-date" v-model="toYear" size="sm" type="number" />
                  </div>
                </b-col>

                <b-col v-if="chartInterval === 'Hourly'" sm="6" md="6" lg="12" class="mt-2">
                  <label for="end-time" :class="infoFieldsClass">End Time</label>
                  <b-form-input id="end-time" v-model="endTime" size="sm" type="time" />
                </b-col>
              </b-row>
              <b-row>
                <div style="padding: 5px; text-align: right">
                  <b-button
                    variant="primary"
                    @click="updateChart()"
                    size="sm"
                    :disabled="searchDisabled || loadingStatus || chartLoading"
                    >Update Chart</b-button
                  >
                </div>
              </b-row>
						</b-form>
						<!-- Data Volume Card -->
					</b-card>
				</b-col>
				<b-col sm="12" md="12" lg="9">
					<div class="diameter-highchart text-center">
						<div class="text-center w-100">
							<p v-if="chartLoading">Searching for usage data on IMSI {{ imsiSearch }}</p>
							<b-icon
								icon="three-dots"
								class="text-center"
								animation="cylon"
								font-scale="4"
								v-if="chartLoading"
							></b-icon>
							<p v-if="!isChartData && !chartLoading">No chart data to display</p>
						</div>
						<div id="chart" v-if="isChartData">
							<highcharts :options="chartOptions"></highcharts>
						</div>
					</div>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import RouteBreadCrumb from "../../../components/Breadcrumb/RouteBreadcrumb";
import troubleshootingService from "../../../common/api-services/troubleshooting-service";
import {Chart} from "highcharts-vue";

import initService from "../../../common/api-services/init-service";
import {MonthPickerInput} from "vue-month-picker";

export default {
	name: "SubscriberUsage",
	components: {
		RouteBreadCrumb,
		Highcharts: Chart,
		MonthPickerInput,
	},
	async mounted() {
		document.title = "Troubleshooting - Subscriber Usage";

		//don't do anything unless the user has access
		if (this.noAccess) {
			this.$router.push("/restricted").catch(() => {});
		}
	},
	data() {
		return {
			chartInterval: "Hourly",
			chartIntervalOptions: ["Hourly", "Daily", "Monthly", "Yearly"],
			startTime: "00:00",
			endTime: "23:00",
			fromYear: new Date().getFullYear(),
			toYear: new Date().getFullYear(),
			fromDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10),
			toDate: new Date().toISOString().substr(0, 10),
			imsiSearch: "",
			loadingStatus: false,
			chartLoading: false,
			infoFieldsClass: "text-nowrap font-weight-600 p-0 m-0",

			chartOptions: {
				chart: {
					zoomType: "x",
				},
				title: {
					text: "Usage",
				},
				xAxis: {type: "datetime"},
				yAxis: {
					title: {
						text: "",
					},
				},
				legend: {
					layout: "vertical",
					align: "right",
					verticalAlign: "middle",
				},
				plotOptions: {
					series: {
						label: {
							connectorAllowed: false,
						},
						marker: {
							enabled: false,
						},
					},
					colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c"],
				},
				series: [],
			},
		};
	},
	computed: {
		noAccess() {
			// Determine access based on menu link configuration
			let userRoles = initService.getUserRoles();
			let link = this.$store.getters["getLinkByLink"](this.$router.currentRoute.path);

			if (!link) {
				return true;
			} else {
				userRoles = userRoles.filter(role => link.roles.includes(role.toUpperCase()));
				return userRoles.length === 0;
			}
		},
		searchDisabled() {
			return !(String(this.imsiSearch).length === 15);
		},
		isChartData() {
			return this.chartOptions.series.length > 0;
		},
	},
	methods: {
		async updateChart() {
			this.chartLoading = true;
			this.chartOptions.series = [];
			let start;
			let end;
			let resolution;

			switch (this.chartInterval) {
				case "Hourly":
					start = this.fromDate + " " + this.startTime + ":00";
					end = this.toDate + " " + this.endTime + ":00";
					resolution = "hour";
					break;
				case "Daily":
					start = this.fromDate + " 00:00:00";
					end = this.toDate + " 23:59:00";
					resolution = "day";
					break;
				case "Monthly":
					start = this.fromDate + " 00:00:00";
					end = this.toDate + " 23:59:00";
					resolution = "month";
					break;
				case "Yearly":
					start = this.fromYear + "-01-01 00:00:00";
					end = this.toYear + "-12-31 23:59:00";
					resolution = "year";
					break;
				default:
					start = this.chartDate + " " + this.startTime + ":00";
					end = this.chartDate + " " + this.endTime + ":00";
			}

			await troubleshootingService.getSubscriberUsageData(this.imsiSearch, start, end, resolution).then(response => {
				if (!String(response.message).toLowerCase().includes("null")) {
					let data = [];
					let retdata = response.message.data;

					var browserDate = new Date();
					var timezoneOffset = browserDate.getTimezoneOffset() * 60 * 1000;
					if (retdata && retdata.length > 0) {
						data.push({
							name: "Data Volume",
							data: retdata.map(e => [
								Date.parse(e["Date"]) - timezoneOffset,
								Number.parseInt(e["Data Volume"]),
							]),
						});
						data.push({
							name: "Data Sessions",
							data: retdata.map(e => [
								Date.parse(e["Date"]) - timezoneOffset,
								Number.parseInt(e["Data Sessions"]),
							]),
						});
						data.push({
							name: "Zero Sessions",
							data: retdata.map(e => [
								Date.parse(e["Date"]) - timezoneOffset,
								Number.parseInt(e["Zero Sessions"]),
							]),
						});
						data.push({
							name: "Alerts",
							data: retdata.map(e => [Date.parse(e["Date"]) - timezoneOffset, Number.parseInt(e["Alerts"])]),
						});
					}
					this.chartOptions.series = data;
				} else if (String(response.message).toLowerCase().includes("null")) {
					this.$toast.info("No chart data found for the selected time period.");
				}
				this.chartLoading = false;
			});
		},

		setStartMonth(value) {
			this.fromDate = new Date(value.from).toISOString().substr(0, 10);
			// console.log({from: this.fromDate});
		},
		setEndMonth(value) {
			this.toDate = new Date(value.to).toISOString().substr(0, 10);
			// console.log({to: this.toDate});
		},
	},
};
</script>

<style scoped>
:deep(.month-picker-input) {
	padding: 4px 8px !important;
	width: 100%;
}
:deep(.month-picker-input-container) {
	min-width: none;
	width: auto;
}
.diameter-highchart {
	border: 10px solid #dee2e6;
	background-color: #dee2e6;
	min-height: 400px;
}
</style>
